import { LoadingButton } from '@mui/lab';
import { Box, Typography } from '@mui/material';
import { ContainerMaxWidth } from 'components/organisms/layouts/Layout';
import { getCookie } from 'cookies-next';
import Image from 'next/image';
import { Colors, DesktopPaddingLarger, MobilePadding } from 'pages/index';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import { useSendCustomSlackMessage } from 'utils/hooks/mutations/user-mutations';
const DEFAULT = {
  email: '',
  name: '',
  dealership: '',
  phone: ''
};
export const ContactUs: FC<{
  subtitle?: string | React.ReactNode;
}> = ({
  subtitle = 'Ready to take your EV sales to the next level? <br /> Fill out the form and schedule a custom demo for your dealership.'
}) => {
  const {
    mutate,
    isLoading
  } = useSendCustomSlackMessage();
  const [form, setForm] = useState(DEFAULT);
  const [nameErr, setNameErr] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const [phoneErr, setPhoneErr] = useState('');
  const [dealerErr, setDealerErr] = useState('');

  // @ts-ignore
  const isDisabled = Object.keys(form).some(key => form[key] === '');
  const referrer = getCookie('referrer') as string || '';
  const submitHandler = async () => {
    const doesHaveErrors = () => {
      let hasError = false;
      // Validate name
      if (!form.name || !/^[a-zA-Z-' ]{2,}$/.test(form.name)) {
        hasError = true;
        setNameErr('Name is invalid');
      } else {
        setNameErr('');
      }

      // Validate email
      if (!form.email || !/^\S+@\S+\.\S+$/.test(form.email)) {
        hasError = true;
        setEmailErr('Email is invalid');
      } else {
        setEmailErr('');
      }

      // Validate dealership name
      if (!form.dealership || !/^[a-zA-Z0-9-' ]{3,}$/.test(form.dealership)) {
        hasError = true;
        setDealerErr('Dealership name is invalid');
      } else {
        setDealerErr('');
      }

      // Validate phone
      if (!form.phone || !/^[\d\s()+-]{7,}$/.test(form.phone)) {
        hasError = true;
        setPhoneErr('Phone is invalid');
      } else {
        setPhoneErr('');
      }
      return hasError;
    };
    const hasErr = doesHaveErrors();
    if (!hasErr) {
      const slackMessage = `*CONTACT US* \nEmail: ${form?.email}\nName: ${form?.name}\nDealership: ${form?.dealership}\nPhone: ${form?.phone}\nReferrer: ${referrer}`;
      Promise.all([mutate({
        message: slackMessage
      })]).then(() => {
        toast('Successfully sent a message');
        setForm(DEFAULT);
        setTimeout(() => {
          window.open(`/select-time?email=${form?.email}&name=${form?.name}&dealership=${form?.dealership}`);
        }, 750);
      }).catch(() => {
        toast('Could not send a message');
      });
    }
  };
  return <Box sx={{
    backgroundColor: Colors.CeruleanBlue,
    p: {
      xs: MobilePadding,
      md: DesktopPaddingLarger
    }
  }}>
      <Box sx={{
      maxWidth: ContainerMaxWidth,
      mx: 'auto'
    }}>
        <Box sx={{
        display: 'flex',
        gap: {
          xs: '1rem',
          md: '2rem'
        },
        flexDirection: {
          xs: 'column',
          md: 'row'
        }
      }}>
          <Box sx={{
          width: '100%'
        }}>
            <Box sx={{
            backgroundColor: '#B9F0D6',
            p: '32px',
            borderRadius: '2px'
          }}>
              <Image src="/assets/svg/handshake.svg" width={40} height={40} alt="" />
              <Typography sx={{
              fontSize: '38px',
              fontWeight: 700,
              my: '1.5rem'
            }}>Let&apos;s chat!</Typography>
              {typeof subtitle === 'string' ? <Typography sx={{
              fontSize: '16px',
              color: '#44485A'
            }} dangerouslySetInnerHTML={{
              __html: subtitle
            }} /> : <Typography sx={{
              fontSize: '16px',
              color: '#44485A'
            }}>{subtitle}</Typography>}
            </Box>
          </Box>
          <Box sx={{
          width: '100%'
        }}>
            <Box sx={{
            backgroundColor: '#FFFFFF',
            p: '24px',
            borderRadius: '2px'
          }}>
              <Box>
                <Typography sx={{
                color: '#44485A',
                fontWeight: 600,
                fontSize: '14px'
              }}>Full name</Typography>
                <input style={{
                border: '1px solid #CCD0E2',
                outline: 'none',
                width: '100%',
                padding: '1rem',
                borderRadius: '2px',
                fontSize: '16px',
                fontFamily: 'Gilroy',
                marginTop: '2px'
              }} value={form?.name} name="name" onChange={e => setForm({
                ...form,
                name: e?.target?.value
              })} />
                {nameErr && <Typography sx={{
                color: 'red',
                fontSize: 11
              }}>{nameErr}</Typography>}
              </Box>
              <Box sx={{
              mt: '1rem'
            }}>
                <Typography sx={{
                color: '#44485A',
                fontWeight: 600,
                fontSize: '14px'
              }}>Dealership</Typography>
                <input style={{
                border: '1px solid #CCD0E2',
                outline: 'none',
                width: '100%',
                padding: '1rem',
                borderRadius: '2px',
                fontSize: '16px',
                marginTop: '2px',
                fontFamily: 'Gilroy'
              }} value={form?.dealership} name="company" onChange={e => setForm({
                ...form,
                dealership: e?.target?.value
              })} />
                {dealerErr && <Typography sx={{
                color: 'red',
                fontSize: 11
              }}>{dealerErr}</Typography>}
              </Box>
              <Box sx={{
              mt: '1rem'
            }}>
                <Typography sx={{
                color: '#44485A',
                fontWeight: 600,
                fontSize: '14px'
              }}>Phone</Typography>
                <input style={{
                border: '1px solid #CCD0E2',
                outline: 'none',
                width: '100%',
                padding: '1rem',
                borderRadius: '2px',
                fontSize: '16px',
                fontFamily: 'Gilroy',
                marginTop: '2px'
              }} value={form?.phone} onChange={e => setForm({
                ...form,
                phone: e?.target?.value
              })} />
                {phoneErr && <Typography sx={{
                color: 'red',
                fontSize: 11
              }}>{phoneErr}</Typography>}
              </Box>
              <Box sx={{
              mt: '1rem'
            }}>
                <Typography sx={{
                color: '#44485A',
                fontWeight: 600,
                fontSize: '14px'
              }}>Email</Typography>
                <input style={{
                border: '1px solid #CCD0E2',
                outline: 'none',
                width: '100%',
                padding: '1rem',
                borderRadius: '2px',
                fontFamily: 'Gilroy',
                fontSize: '16px',
                marginTop: '2px'
              }} value={form?.email} onChange={e => setForm({
                ...form,
                email: e?.target?.value
              })} />
                {emailErr && <Typography sx={{
                color: 'red',
                fontSize: 11
              }}>{emailErr}</Typography>}
              </Box>

              <LoadingButton loading={isLoading} disabled={isDisabled} onClick={() => {
              if (!isDisabled) {
                submitHandler();
              }
            }} style={{
              color: Colors.White,
              backgroundColor: Colors.CeruleanBlue,
              display: 'block',
              marginTop: '1rem',
              textAlign: 'center',
              border: `1px solid ${Colors.CeruleanBlue}`,
              fontWeight: 600,
              textTransform: 'none',
              height: '50px',
              textDecoration: 'none',
              fontFamily: 'Gilroy',
              width: '100%',
              borderRadius: '2px'
            }}>
                Let&apos;s chat
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>;
};